import RemoteCollection from "#root/utility/remote-collection";
import * as z from "zod";

export const CloudScheduleTaskListItemSchema = z.object({
  id: z.number(),
  name: z.string(),
  lastStarted: z.string().nullish(),
  lastFinished: z.string().nullish(),
  lastStatus: z.string().nullish(),
  lastOutput: z.string().nullish(),
});

export const CloudScheduleTaskDetailSchema = CloudScheduleTaskListItemSchema.extend({
  type: z.string(),
  nextWakeup: z.string().nullish(),
  timing: z.any(),
  input: z.any(),
  createdAt: z.string(),
  updatedAt: z.string(),
  lastJobId: z.string().nullish(),
}).loose();

export const cloudScheduleTaskCollection = new RemoteCollection("/api/cloudschedule/task", CloudScheduleTaskListItemSchema, CloudScheduleTaskDetailSchema);

export const CloudScheduleJobListItemSchema = z.object({
  id: z.string(),
  startTime: z.string().nullish(),
  endTime: z.string().nullish(),
  status: z.string().nullish(),
  output: z.string().nullish(),
});

export const CloudScheduleJobDetailsSchema = CloudScheduleJobListItemSchema.extend({
  log: z.string().nullish(),
}).loose();

export type CloudScheduleJobListItem = z.output<typeof CloudScheduleJobListItemSchema>;
export type CloudScheduleJobDetails = z.output<typeof CloudScheduleJobDetailsSchema>;

export function getCloudScheduleJobCollectionForTask(taskId: string) {
  return new RemoteCollection(`/api/cloudschedule/task/${taskId}/job`, CloudScheduleJobListItemSchema, CloudScheduleJobDetailsSchema);
}
